// components/PaymentLogsTable.js
import React, { useEffect } from "react";
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import { API_URL } from "..";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const PaymentLogsTable = ({ logsData }) => {


    const deletePayment= async(id)=>{
        const api  = await fetch(API_URL+'/api/payments/'+id, {method:'DELETE'});
        const json  = await api.json();
        if(api.status ===200){
          toast.success('Payment deleted successfully!', {
            position: 'top-right',
            autoClose: 3000,
          });
          window.location.reload()
        }
        
      }
  useEffect(() => {
    const table = $("#paymentLogsTable").DataTable({
      data: logsData,
      destroy: true, // ✅ prevents reinit issues
      responsive: true,
      pageLength: 10,
      order: [[0, "desc"]],
      columns: [
        { data: "invoice.invoice_number", title: "ID" },
        { data: "account.accountTitle", title: "Account ID",
        render: function (data, type, row) { 
            return ` ${data} (${row?.account.type})`
          }, },
        { data: "userName", title: "Record By" },
        // { data: "payment_status", title: "Status" },
        {
          data: "total_amount",
          title: "Total Amount",
          render: function (data, type, row) { 
            return `${row?.invoice?.currency} ${parseFloat(data).toFixed(2)}`
          },
        },
        {
          data: "received_amount",
          title: "Received Amount",
          render: function (data, type, row) { 
            return `${row?.invoice?.currency} ${parseFloat(data).toFixed(2)}`
          },
        },
        {
          data: "remaining_balance",
          title: "Remaining Balance",
          render: function (data, type, row) { 
            return `${row?.invoice?.currency} ${parseFloat(data).toFixed(2)}`
          },
        },
        {
          data: "createdAt",
          title: "Payment Date",
          render: (data) => new Date(data).toLocaleString(),
        },
        {
          data: "id",
          title: "Actions",
          render: function (data, type, row) { 
            return `<button data-id="${data}" class="btn btn-danger delete-btn">Delete</button>`
          },
        },
      ],
    });
    $('#paymentLogsTable tbody').on('click', '.delete-btn', function () {
        const id = $(this).data('id');
         deletePayment(id)      
    });
    return () => {
      table.destroy(true);
    };
  }, [logsData]);

  return (
    <div className="card basic-data-table mt-3">
      <div className="card-header">
        <h5 className="card-title mb-0">Payment Logs</h5>
      </div>
      <div className="card-body">
        <table
          className="table bordered-table mb-0"
          id="paymentLogsTable"
          style={{ width: "100%" }}
        >
          <thead>
            <tr>
              <th>ID</th>
              <th>Account ID</th>
              <th>User ID</th>
              {/* <th>Status</th> */}
              <th>Total Amount</th>
              <th>Received Amount</th>
              <th>Remaining Balance</th>
              <th>Created At</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>
    </div>
  );
};

export default PaymentLogsTable;
